/**
 * @fileoverview POST handler for the "/companies/:company_id/developers/:developer_id/unsuspend" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersDeveloperIdUnsuspendCacheKeys } from "./constants";
import type { PostCompaniesCompanyIdDevelopersDeveloperIdUnsuspendProps, DeveloperUnsuspendResult } from "./types";

export const postDeveloperUnsuspend = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersDeveloperIdUnsuspendCacheKeys,
  (props: PostCompaniesCompanyIdDevelopersDeveloperIdUnsuspendProps): Promise<DeveloperUnsuspendResult> => {
    return fetch(`/companies/${props.companyId}/developers/${props.developerId}/unsuspend`, "POST", props);
  }
);
